module.exports = {"350625100":"武安镇","350625101":"岩溪镇","350625102":"陈巷镇","350625103":"枋洋镇","350625200":"坂里乡","350625400":"国营古农农场","350625500":"长泰经济开发区","350625501":"马洋溪生态旅游区","350625502":"林墩工业区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/350625.json
// module id = 1326
// module chunks = 0